import React from 'react';
import { ConnectWallet } from '@components/CollectButton/shared';
import { Button } from '@components/main-components/button/Button';
import { useAuth } from '@context/auth/base';
import { DataTestId } from '@utils/test';

export const SellButton = ({
  onSell,
  disabled,
  loading,
}: {
  onSell: () => void;
  disabled?: boolean;
  loading?: boolean;
}) => {
  const { isAuthenticatedWithAPI } = useAuth();

  return !!isAuthenticatedWithAPI ? (
    <Button
      data-testid={DataTestId.RELEASE_PAGE_SELL_BUTTON}
      variant="fuchsia"
      fullWidth
      label="Sell Now"
      size="XL"
      disabled={disabled}
      loading={loading}
      onClick={onSell}
    />
  ) : (
    <ConnectWallet fullWidth sourceComponent="Mint Component" />
  );
};
